<template>
    <transition name="modal">
        <div id="assignmentToTalkgroup" class="dialog-modal-mask">
            <div v-if="isTalkgroupSelected">
                <div class="large-panel" @click.stop>
                    <div class="dialog-title">
                        <div v-t="'message.action_assignment_User'"></div>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-body">
                        <table width=100% height=100% cellpadding=0 cellspacing=0>
                            <tr>
                                <td class="selected-td" colspan="2">
                                    <div class="inner-panel-header">
                                        <div class="inner-panel-title" style="width: 100%;">
                                            <div class="inner-panel-title-left" v-t="'message.title_assignment_selectedGroup'">
                                            </div>
                                        </div>
                                    </div>
                                    <div id="selected-user" class="inner-panel-dialog" style="height: calc(15vh); width: 100%;">
                                        <div class="selected-item-field">
                                            <span v-for="tag in selectionColumn.data" v-bind:key="tag.id">
                                                <div class="selectedTag">
                                                    <span class="selectedTag-name" style="max-width: 100%;">{{ tag.displayName }}</span>
                                                    <span class="closeTag"></span>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="dialoginputfield">
                                <td colspan=2>
                                    <hr class="dialog-hr">
                                    <div style="padding: 10px;">
                                        <el-form @submit.native.prevent="findUser()">
                                            <el-radio-group style="padding-left:10px" v-model="listType" fill="#5171cb">
                                                <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                                <el-radio-button :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                                            </el-radio-group>
                                            <el-input v-if="listType == 1" :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" clearable class="object-search-select">
                                                <el-select v-model="conditionUser" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                                    <el-option :label="$t('message.item_user_name')" value="name"></el-option>
                                                    <el-option :label="$t('message.item_userDisplayName')" value="displayName"></el-option>
                                                    <el-option :label="$t('message.item_organization')" value="organization"></el-option>
                                                    <el-option :label="$t('message.item_job_title')" value="title"></el-option>
                                                </el-select>
                                                <el-button slot="append" style="width: 100px;vertical-align:middle" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                            </el-input>
                                        </el-form>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="dialog-td">
                                    <div class="inner-panel-header">
                                        <div class="inner-panel-title">
                                            <div class="inner-panel-title-left" v-t="'message.title_select_user'">
                                            </div>
                                            <div v-if="listType == 1" class="inner-panel-title-right">
                                                <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="listType == 0" class="inner-panel-dialog" style="height: calc(65vh - 282px);">
                                        <dialogtreemultitype
                                            class="dialog-tree"
                                            v-bind:initialData="tenantList"
                                            @on-selectnode="handleOnSelectUserAndIP"
                                            :selection-multi-type="[OBJECT_USER, OBJECT_IP_RADIO]"
                                            ref="dialogTree">
                                        </dialogtreemultitype>
                                    </div>
                                    <div v-else class="inner-panel-dialog" style="height: calc(65vh - 282px);">
                                        <div class="foundObject-record" v-for="object in foundUserList" @click="addUserTag(object)">
                                            <div class="foundObject">
                                                <span style="padding-left:10px;vertical-align:middle">{{ object.displayName }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="dialog-td">
                                    <div class="inner-panel-header">
                                        <div class="inner-panel-title">
                                            <div class="inner-panel-title-left" v-t="'message.title_assignment_addUser'">
                                            </div>
                                            <div class="inner-panel-title-right">
                                                <button class="transparent" @click="removeAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.action_delete_all'"></span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="selected-user" class="inner-panel-dialog" style="height: calc(65vh - 282px);">
                                        <div class="selected-item-field">
                                            <div class="default-message" v-if="Object.keys(editTagList) == 0" v-html="$t('message.hint_add_group_to_user')">
                                            </div>
                                            <span v-for="tag in editTagList" v-bind:key="tag.id">
                                                <div class="userTag">
                                                    <span class="userTag-name">{{ tag.displayName }}</span>
                                                    <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" :disabled="this.disableSave" @click="saveUpdatedInfo()" v-t="'message.button_save'"></el-button>
                    </div>
                </div>
            </div>
            <!-- 以下ユーザー選択時 -->
            <div v-else>
                <div class="large-panel" @click.stop>
                    <div class="dialog-title">
                        <div v-t="'message.action_assignment_to_talkgroup'"></div>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-body">
                        <table width=100% height=100% cellpadding=0 cellspacing=0>
                            <tr>
                                <td class="selected-td" colspan="2">
                                    <div class="inner-panel-header">
                                        <div class="inner-panel-title" style="width: 100%;">
                                            <div class="inner-panel-title-left" v-t="'message.title_assignment_selectedUser'"></div>
                                        </div>
                                    </div>
                                    <div id="selected-user" class="inner-panel-dialog" style="height: calc(15vh); width: 100%;">
                                        <div class="selected-item-field">
                                            <span v-for="tag in selectionColumn.data" v-bind:key="tag.id">
                                                <div class="selectedTag">
                                                    <span class="selectedTag-name" style="max-width: 100%;">{{ tag.displayName }}</span>
                                                    <span class="closeTag"></span>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="dialoginputfield">
                                <td colspan=2>
                                    <hr class="dialog-hr">
                                    <div style="padding: 10px;">
                                        <el-form @submit.native.prevent="findGroup()">
                                            <el-radio-group style="padding-left:10px" v-model="listType" fill="#5171cb">
                                                <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                                <el-radio-button :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                                            </el-radio-group>
                                            <el-input v-if="listType == 1" :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" clearable class="object-search-select">
                                                <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                                    <el-option :label="$t('message.item_groupId')" value="groupId"></el-option>
                                                    <el-option :label="$t('message.item_groupDisplayName')" value="groupName"></el-option>
                                                </el-select>
                                                <el-button slot="append" style="width: 100px;vertical-align:middle" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                            </el-input>
                                        </el-form>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="dialog-td">
                                    <div class="inner-panel-header">
                                        <div class="inner-panel-title">
                                            <div class="inner-panel-title-left" v-t="'message.title_select_group'">
                                            </div>
                                            <div v-if="listType == 1" class="inner-panel-title-right">
                                                <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="listType == 0" class="inner-panel-dialog" style="height: calc(65vh - 282px);">
                                        <dialogtreemultitype
                                            class="dialog-tree"
                                            v-bind:initialData="tenantList"
                                            @on-selectnode="handleOnSelectGroup"
                                            :selection-multi-type="[OBJECT_TALKGROUP]"
                                            ref="dialogTree">
                                        </dialogtreemultitype>
                                    </div>
                                    <div v-else class="inner-panel-dialog" style="height: calc(65vh - 282px);">
                                        <div class="foundObject-record" v-for="object in foundGroupList" @click="addUserTag(object.node.data)">
                                            <div class="foundObject">
                                                <span style="padding-left:10px;vertical-align:middle">{{ object.node.data.label }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="dialog-td">
                                    <div class="inner-panel-header">
                                        <div class="inner-panel-title">
                                            <div class="inner-panel-title-left" v-t="'message.title_assignment_addGroup'">
                                            </div>
                                            <div class="inner-panel-title-right">
                                                <button class="transparent" @click="removeAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.action_delete_all'"></span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="selected-user" class="inner-panel-dialog" style="height: calc(65vh - 282px);">
                                        <div class="selected-item-field">
                                            <div class="default-message" v-if="Object.keys(editTagList) == 0" v-html="$t('message.hint_add_group_to_user')">
                                            </div>
                                            <span v-for="tag in editTagList" v-bind:key="tag.id">
                                                <div class="userTag">
                                                    <span class="userTag-name">{{ tag.displayName }}</span>
                                                    <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" :disabled="this.disableSave" @click="saveUpdatedInfo()" v-t="'message.button_save'"></el-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import DialogTree from "./DialogTree.vue";
import DialogTreeMultiType from './DialogTreeMultiType.vue';
import commonUtil from './commonutil.js';
import constants from './constants.js';

const STATUS_SUCCESS = 0;
const STATUS_ALREADY_EXIST = -1;
const STATUS_UNMATCH_SPEECH_TO_TEXT = -2;
const STATUS_UNMATCH_TRANSLATION = -3;
const STATUS_UNMATCH_MAPTALK = -4;
const STATUS_UNMATCH_VIDEO = -5;
const STATUS_TOO_MANY_TAGS = -6;
const STATUS_LINK_GROUP = -7;

export default {
    components: {
        dialogtree: DialogTree,
        dialogtreemultitype: DialogTreeMultiType
    },

    props: ['appData','userAttribute','selectionColumn'],

    data() {
        return {
            OBJECT_USER: constants.OBJECT_USER,
            OBJECT_TALKGROUP: constants.OBJECT_TALKGROUP,
            OBJECT_IP_RADIO: constants.OBJECT_IP_RADIO,

            scrollOnAction: false,
            existExternalGroup: false,
            tenantList: [],
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            foundGroupList: [],
            foundUserList: [],
            listType: 0,
            condition: "groupId",
            conditionUser: "name",
            searchString: null,
            disableSave: true,
            assignmentLimit: 0,
            isTalkgroupSelected: true,
            talkgroupAttributeTotal: {},
            userAttributeTotal: {}
        };
    },

    created: function() {
        this.disableSave = true;
        this.tenantList = [];
        this.tenantList.push(this.appData.tenantList[0]);
        this.assignmentLimit = this.calculateAssignmentLimit();
        if(this.selectionColumn.type == constants.TABLE_OPTIONS.group.value){
            this.isTalkgroupSelected = true;
            this.talkgroupAttributeTotal = this.mergeGroupOptions(this.selectionColumn.data);
        }else{
            if(this.selectionColumn.type == constants.TABLE_OPTIONS.buddycomAccount.value){
                this.userAttributeTotal = this.mergeUserOptions(this.selectionColumn.data);
            }else if(this.selectionColumn.type == constants.TABLE_OPTIONS.ipRadioAccount.value){
                this.userAttributeTotal = this.mergeRadioOptions(this.selectionColumn.data);
            }
            this.isTalkgroupSelected = false;
        }
    },

    updated: function() {
        if (this.scrollOnAction) {
            let obj = document.getElementById("selected-user");
            obj.scrollTop = obj.scrollHeight;
            this.scrollOnAction = false;
        }
    },

    methods: {

        findGroup() {
            let param = {tenantId: this.appData.tenantList[0].tenantId}
            if (this.condition == "groupId") {
                param.name = this.searchString;
            } else if (this.condition == "groupName") {
                param.displayName = this.searchString;
            }
            let self = this;
            server.post("/findgroup", param)
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        if (res.data.groupInfo.length == 0) {
                            self.foundGroupList = [];
                            commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_group_not_found").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_group")));
                            return;
                        }
                    } else {
                        self.foundGroupList = [];
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findGroup").replace("{code}",res.data.status));
                        return;
                    }
                    self.foundGroupList = [];
                    for (let objectInfo of res.data.groupInfo) {
                        let object = { node : { data: null, parent: { data: null} } }
                        object.node.data = {
                            id: self.appData.tenantList[0].tenantId + "-" + objectInfo.id,
                            tenantId: self.appData.tenantList[0].tenantId,
                            type: constants.OBJECT_TALKGROUP,
                            talkgroupId: objectInfo.id,
                            talkgroupName: objectInfo.name ,
                            displayName: objectInfo.displayName,
                            label: objectInfo.name,
                            optionFlag: objectInfo.optionFlag
                        };
                        object.node.parent.data = {id: objectInfo.pid}
                        self.foundGroupList.push(object);
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "findGroup", error);
                    self.foundGroupList = [];
                });
        },
        findUser: function() {
            let dataList = [];
            this.existImportGroup = false;
            for(let i = 0; i < this.tenantList.length; i++) {
                let param = {tenantId: this.tenantList[i].tenantId}
                if (this.conditionUser == "name") {
                    param.name = this.searchString;
                } else if (this.conditionUser == "displayName") {
                    param.displayName = this.searchString;
                } else if (this.conditionUser == "organization") {
                    if (this.searchString != "") {
                        param.organization = this.searchString;
                    }
                } else if (this.conditionUser == "title") {
                    if (this.searchString != "") {
                        param.title = this.searchString;
                    }
                } else {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_search_condition_not_found"));
                    return;
                }
                dataList.push(param)
            }

            let self = this;
            self.foundUserList = [];
            let getUserList = {};
            let tooManyUsers = false;
            let getResultCount = 0;
            for (let i = 0; i < dataList.length; i++) {
                let data = dataList[i]
                let tenantListIdx = i;
                server.post('/finduser', data)
                    .then((res) => {
                        getResultCount ++;
                        if (res.data.status != 0) {
                            switch (res.data.status) {
                                case -7:
                                    tooManyUsers = true;
                                    break;
                                case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted"));
                                    break;
                                default:
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findUser").replace("{code}",res.data.status));
                                    break;
                            }
                            return;
                        }
                        let tenantName = commonUtil.getTenantName(self.appData, data.tenantId);
                        for (let i = 0; i < res.data.userInfo.length; i++) {
                            let userInfo = res.data.userInfo[i]
                            if (!self.showAdminUser &&
                                res.data.userInfo[i].restrictions != null &&
                                res.data.userInfo[i].restrictions.includes(constants.RESTRICTION_LOGIN)
                            ) {
                                continue;
                            }

                            let key = data.tenantId + '-' + userInfo.id
                            Vue.set(getUserList, key, {
                                    id: key,
                                    tenantId: data.tenantId,
                                    userId: userInfo.id,
                                    tenantName: tenantName ,
                                    userName: userInfo.name ,
                                    userOptions: userInfo.userOptions ,
                                    defaultFlag: false,
                                    displayName: userInfo.displayName,
                                    orgRestrictions: userInfo.restrictions,
                                    orgRights: userInfo.rights,
                                    orgPublishInformations: userInfo.publishInformations,
                                    type: userInfo.type
                            });
                        }
                        if (getResultCount == this.tenantList.length) {
                            if (tooManyUsers) {
                                self.foundUserList = [];
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"info_too_many_users"));
                                return;
                            }
                            if (Object.keys(getUserList).length == 0) {
                                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_user_not_found"));
                                return;
                            }

                            // set sorted result to user-list
                            var tempArray = [];
                            for (let objectKey in getUserList) {
                                tempArray.push(objectKey);
                            }
                            tempArray.sort(function(a,b){
                                if( a < b ) return -1;
                                if( a > b ) return 1;
                                return 0;
                            });
                            for (var i = 0; i < tempArray.length; i++) {
                                // Vue.set(self.foundUserList, tempArray[i], getUserList[tempArray[i]]);
                                self.foundUserList.push(getUserList[tempArray[i]])
                            }
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "findUser", error);
                    });
            }
        },
        handleOnSelectUserAndIP(data,node) {
            if (data.type == constants.OBJECT_USER || data.type == constants.OBJECT_IP_RADIO) {
                let key = data.tenantId + "-" + data.id;
                if ((key in this.editTagList)) {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_group_already_added"));
                    return;
                }
            } else {
                return;
            }
            let tenantName = commonUtil.getTenantName(this.appData, data.tenantId);
            let key = data.tenantId + "-" + data.id;
            if (!(key in this.editTagList)) {
                if (data.type == constants.OBJECT_USER){
                    this.addUserTagAfterFetch(data.tenantId , tenantName , data.id ,data.type);
                }else{
                    this.addUserTagAfterFetch(data.tenantId , tenantName , data.id ,data.type);
                    // this.addUserTag({ tenantId: data.tenantId, tenantName: tenantName, userId: data.id, userName: data.name, displayName: data.displayName, id: key, type: data.type});
                }
            } else {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_user_already_added"));
            }
        },
        addUserTagAfterFetch(tenantId , tenantName , userId , type) {
            let self = this;
            server.post('/getinfo', {tenantId: tenantId, id: userId})
                .then((res) => {
                    if (res.data.status >= 0) {
                        let key = tenantId + '-' + userId;
                        let tagInfo = {
                            id: key,
                            tenantId: tenantId,
                            userId: userId,
                            tenantName: tenantName ,
                            userName: res.data.name ,
                            userOptions: res.data.userOptions ,
                            defaultFlag: false,
                            displayName: res.data.displayName,
                            type: type
                        };
                        this.addUserTag(tagInfo);
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addUserInfoTag").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "addUserInfoTag", error);
                });
        },
        handleOnSelectGroup(data,node) {
            // add talkGroup to user

            if (data.type == constants.OBJECT_TALKGROUP) {
                let key = data.tenantId + "-" + data.id;
                if ((key in this.editTagList)) {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_group_already_added"));
                    return;
                }
            } else {
                return;
            }

            let self = this;
            let tenantId = data.tenantId;
            let talkgroupId = data.id;
            server.post('/getinfo', {tenantId: tenantId, id: talkgroupId})
                .then((res) => {
                    if (res.data.status >= 0) {
                        let key = tenantId + '-' + talkgroupId;
                        let displayName;
                        if (self.appData.tenantList[0].tenantId == tenantId) {
                            displayName = res.data.name
                        } else {
                            displayName = res.data.name + "(" + tenantName + ")"
                        }
                        let tagInfo = {
                            id: key,
                            tenantId: tenantId,
                            userTenantId: self.appData.tenantList[0].tenantId,
                            talkgroupTenantId: tenantId,
                            talkgroupId: res.data.id ,
                            talkgroupName: res.data.name ,
                            talkgroupOptions: res.data.talkgroupOptions ,
                            tenantName: commonUtil.getTenantName(self.appData, tenantId) ,
                            defaultFlag: false,
                            displayName: displayName,
                            type: constants.OBJECT_TALKGROUP
                        };
                        this.addUserTag(tagInfo);
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleOnSelectNode").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "handleOnSelectNode", error);
                });
        },

        selectTagAll() {
            if(this.isTalkgroupSelected){
                let addUserCount = 0;
                for (let userNode of this.foundUserList) {
                    let tagInfo = userNode;
                    let condition = this.checkConditionToAdd(tagInfo);
                    if (condition === STATUS_SUCCESS) {
                        this.addUserTagInternal(tagInfo)
                        addUserCount ++;
                    } else if (condition === STATUS_TOO_MANY_TAGS) {
                        this.notifyTooManyAssignmentTags();
                        return;
                    }
                }
                if (addUserCount !== this.foundUserList.length) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_all_object").replace("{object}",commonUtil.getMessageText(this.$i18n,"item_group")));
                }
            }else{
                let addGroupCount = 0;
                for (let groupNode of this.foundGroupList) {
                    let tagInfo = groupNode.node.data;
                    let condition = this.checkConditionToAdd(tagInfo);
                    if (condition === STATUS_SUCCESS) {
                        this.addUserTagInternal(tagInfo)
                        addGroupCount ++;
                    } else if (condition === STATUS_TOO_MANY_TAGS) {
                        this.notifyTooManyAssignmentTags();
                        return;
                    }
                }
                if (addGroupCount !== this.foundGroupList.length) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_all_object").replace("{object}",commonUtil.getMessageText(this.$i18n,"item_group")));
                }
            }
        },

        addUserTag(tagInfo) {
            switch(this.checkConditionToAdd(tagInfo)) {
                case STATUS_SUCCESS:
                    this.addUserTagInternal(tagInfo);
                    break;
                case STATUS_ALREADY_EXIST:
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_group_already_added"));
                    break;
                case STATUS_UNMATCH_SPEECH_TO_TEXT:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_speechText"));
                    break;
                case STATUS_UNMATCH_TRANSLATION:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_translation"));
                    break;
                case STATUS_UNMATCH_MAPTALK:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_mapTalk"));
                    break;
                case STATUS_UNMATCH_VIDEO:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_video"));
                    break;
                case STATUS_TOO_MANY_TAGS:
                    this.notifyTooManyAssignmentTags();
                    break;
            }
        },

        checkConditionToAdd(tagInfo) {
            if (!(tagInfo.id in this.removeTagList)) {
                if (Object.keys(this.addTagList).length + Object.keys(this.removeTagList).length >= this.assignmentLimit) {
                    return STATUS_TOO_MANY_TAGS;
                }
            }

            // check user/group option (user selection for group)
            if(tagInfo.type == constants.OBJECT_USER){
                let key = tagInfo.tenantId + '-' + tagInfo.userId
                if (key in this.editTagList) {
                    return STATUS_ALREADY_EXIST;
                }
                if (this.talkgroupAttributeTotal.speechToText && !tagInfo.userOptions.speechToText) {
                    return STATUS_UNMATCH_SPEECH_TO_TEXT;
                }
                if (this.talkgroupAttributeTotal.translation && !tagInfo.userOptions.translation) {
                    return STATUS_UNMATCH_TRANSLATION;
                }
                if (this.talkgroupAttributeTotal.mapTalk && !tagInfo.userOptions.mapTalk) {
                    return STATUS_UNMATCH_MAPTALK;
                }
                if (this.talkgroupAttributeTotal.video && !tagInfo.userOptions.video) {
                    return STATUS_UNMATCH_VIDEO;
                }
            }else if(tagInfo.type == constants.OBJECT_IP_RADIO){
                let key = tagInfo.tenantId + '-' + tagInfo.userId
                if (key in this.editTagList) {
                    return STATUS_ALREADY_EXIST;
                }
                if (this.talkgroupAttributeTotal.speechToText && !tagInfo.userOptions.speechToText) {
                    return STATUS_UNMATCH_SPEECH_TO_TEXT;
                }
                if (this.talkgroupAttributeTotal.translation && !tagInfo.userOptions.translation) {
                    return STATUS_UNMATCH_TRANSLATION;
                }
            }else if(tagInfo.type == constants.OBJECT_TALKGROUP){
                if (tagInfo.id in this.editTagList) {
                    return STATUS_ALREADY_EXIST;
                }
                if (!this.userAttributeTotal.speechToText &&
                        ((tagInfo.talkgroupOptions && tagInfo.talkgroupOptions.speechToTextEngine > 0) || ((tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_SPEECH_TEXT)) !== 0))) {
                    return STATUS_UNMATCH_SPEECH_TO_TEXT;
                }
                if (!this.userAttributeTotal.translation &&
                        ((tagInfo.talkgroupOptions && tagInfo.talkgroupOptions.translationEngine > 0) || ((tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_TRANSLATION)) !== 0))) {
                    return STATUS_UNMATCH_TRANSLATION;
                }
                if(this.selectionColumn.type == constants.TABLE_OPTIONS.buddycomAccount.value){
                    if (!this.userAttributeTotal.mapTalk &&
                            ((tagInfo.talkgroupOptions && tagInfo.talkgroupOptions.mapTalk) || ((tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_MAP_TALK)) !== 0))) {
                        return STATUS_UNMATCH_MAPTALK;
                    }
                    if (!this.userAttributeTotal.video &&
                            ((tagInfo.talkgroupOptions && tagInfo.talkgroupOptions.video) || ((tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_VIDEO)) !== 0))) {
                        return STATUS_UNMATCH_VIDEO;
                    }
                }
            }
            return STATUS_SUCCESS;
        },

        addUserTagInternal(tagInfo) {
            this.scrollOnAction = true;
            Vue.set(this.editTagList, tagInfo.id , tagInfo);
            Vue.delete(this.removeTagList, tagInfo.id);
            if (!(tagInfo.id in this.orgTagList)) {
                Vue.set(this.addTagList, tagInfo.id, tagInfo);
            }
            this.disableSave = false;
            return true;
        },

        removeAllUserTag() {
            if (this.existExternalGroup) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_all_group_by_link"));
                return;
            }

            for (let tagKey in this.editTagList) {
                let result = this.removeUserTag(this.editTagList[tagKey])
                if (result !== STATUS_SUCCESS) {
                    return;
                }
            }
        },

        removeUserTag(tag) {
            if (!this.isEnableSave(tag.tenantId)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_group_by_link"));
                return STATUS_LINK_GROUP;
            }

            if (!(tag.id in this.addTagList)) {
                if (Object.keys(this.addTagList).length + Object.keys(this.removeTagList).length >= this.assignmentLimit) {
                    this.notifyTooManyAssignmentTags();
                    return STATUS_TOO_MANY_TAGS;
                }
            }

            if ((tag.id in this.orgTagList)) {
                Vue.set(this.removeTagList, tag.id, tag);
            }

            Vue.delete(this.addTagList, tag.id);
            Vue.delete(this.editTagList, tag.id)
            this.disableSave = false;

            return STATUS_SUCCESS
        },

        saveUpdatedInfo() {
            this.$emit('save' , this.addTagList,this.selectionColumn.data, this.selectionColumn.type);
        },

        isEnableSave(tenantId) {
            if (tenantId === this.appData.tenantList[0].tenantId) {
                return true;
            }
            for (let exportedTenant of this.appData.exportedTenantList) {
                if (exportedTenant.tenantId === tenantId) {
                    return false;
                }
            }
            return false;
        },
        calculateAssignmentLimit() {
            const selectedCount = Array.isArray(this.selectionColumn.data) ? this.selectionColumn.data.length : 0;
            if (selectedCount <= 0) {
                return 0;
            }
            return Math.floor(1000 / selectedCount);
        },
        notifyTooManyAssignmentTags() {
            commonUtil.notifyMessage(
                this,
                "Warning",
                commonUtil.getMessageText(this.$i18n,"error_too_many_assignment_tags")
            );
        },
        mergeGroupOptions(selectGroups){
            let options = {
                mapTalk: false,
                speechToText: false,
                translation: false,
                video: false,
            };
            for(const group of selectGroups){
                options.mapTalk ||= group.mapTalk;
                options.speechToText ||= group.speechToText;
                options.translation ||= group.translation;
                options.video ||= group.video;
            }
            return options;
        },
        mergeUserOptions(selectUser){
            let options = {
                mapTalk: true,
                speechToText: true,
                translation: true,
                video: true,
            };
            for(const user of selectUser){
                options.mapTalk &&= user.userOptions.mapTalk;
                options.speechToText &&= user.userOptions.speechToText;
                options.translation &&= user.userOptions.translation;
                options.video &&= user.userOptions.video;
            }
            return options;
        },
        mergeRadioOptions(selectRadio){
            let options = {
                speechToText: true,
                translation: true,
            };
            for(const radio of selectRadio){
                options.speechToText &&= radio.speechToText;
                options.translation &&= radio.translation;
            }
            return options;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}
.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}
.selected-td {
    width: 100%;
    vertical-align: top;
    margin: 0;
    padding: 0;
}
.selectedTag {
  display: inline-block;
  border: 1px solid;
  border-radius: 30px;
  border-color: #1F2E4B;
  color: #1F2E4B;
  margin: 5px;
  padding: 6px 10px;
  white-space: nowrap;
  word-break: break-word;
  text-align: justify;
}
.selectedTag > .selectedTag-name {
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  max-width: 100%;
}
</style>
